import React from 'react';
import Badge from './UI/Badge';
import Button from './UI/Button';
import './TopicCard.css';

export default function TopicCard({ topic, isSubscribed, onSubscribe, onUnsubscribe }) {
  return (
    <div className={`topic-card${isSubscribed ? ' topic-card--subscribed' : ''}`}>
      <div className="topic-card-header">
        <div className="topic-card-icon">{topic.icon}</div>
        <div className="topic-card-meta">
          <Badge variant="default">{topic.category}</Badge>
          {isSubscribed && <Badge variant="subscribed">✓ Subscribed</Badge>}
        </div>
      </div>

      <h3 className="topic-card-title">{topic.name}</h3>
      <p className="topic-card-desc">{topic.description}</p>

      <div className="topic-card-footer">
        <span className="topic-card-subs">
          {topic.subscribers.toLocaleString()} subscribers
        </span>
        {isSubscribed ? (
          <Button variant="outline" size="sm" onClick={onUnsubscribe}>
            Manage
          </Button>
        ) : (
          <Button variant="primary" size="sm" onClick={onSubscribe}>
            Subscribe
          </Button>
        )}
      </div>

      {isSubscribed && <div className="topic-card-accent-bar" />}
    </div>
  );
}
